const LoginSignUpForm = {
    baseStyle: {
        modal: {
            size: 'lg',
            scrollBehavior: 'inside'
        },
        modalContent: {
            borderRadius: '6px',
            padding: {base: '30px 20px', lg: '30px'},
            maxH: '90vh',
            maxWidth: {base: '90vw', lg: '700px'},
            display: 'flex',
            flexDirection: 'column'
        },
        modalHeading: {
            fontSize: '26px',
            fontWeight: '400',
            lineHeight: 'normal',
            letterSpacing: '0.13px',
            color: 'black.100'
        },
        login: {
            body: {
                marginTop: '30px',
                padding: '0px'
            },
            resetPassword: {
                color: 'black.100',
                fontSize: '14px',
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '4px',
                transition: 'color 0.2s ease',
                width: 'fit-content',
                fontWeight: '300',
                letterSpacing: '0.07px',
                marginLeft: 'auto',
                _hover: {
                    color: 'teal.400'
                },
                lineHeight: '22px'
            },
            dontHaveAccount: {
                fontWeight: '300',
                fontSize: '16px',
                lineHeight: '25px',
                letterSpacing: '0.08px',
                color: 'black.100'
            },
            alreadyAccountWrapper: {
                display: 'inline-flex',
                gap: '10px',
                margin: 'auto'
            },
            signUpLink: {
                fontWeight: '400',
                fontSize: '16px',
                color: 'black.100',
                cursor: 'pointer',
                lineHeight: '25px',
                textDecoration: 'underline',
                transition: 'color 0.2s ease',
                _hover: {
                    color: 'teal.400'
                },
                textUnderlineOffset: '4px'
            }
        },
        signup: {
            body: {
                padding: '0px',
                margin: '0px',
                sx: {
                    '&::-webkit-scrollbar': {
                        width: '2px'
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'transparent'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'gray.800',
                        borderRadius: '10px'
                    }
                }
            },
            vStack: {
                as: 'form',
                gap: '30px',
                align: 'stretch'
            },
            description: {
                fontSize: '13px',
                color: 'black.100',
                fontWeight: '300',
                letterSpacing: '0.065px',
                lineHeight: '22px'
            },
            required: {
                fontSize: '16px',
                fontWeight: '300',
                letterSpacing: '0.08px',
                lineHeight: '25px',
                color: 'black.300'
            },
            checkbox: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',

                sx: {
                    '.chakra-checkbox__control': {
                        border: '1px solid var(--chakra-colors-gray-600)',
                        borderColor: 'gray.600',
                        background: 'gray.200',

                        // this is the key fix
                        marginTop: '3px',

                        svg: {
                            stroke: 'purple.100 !important'
                        }
                    },

                    '.chakra-checkbox__label': {
                        margin: '0px'
                    }
                }
            },
            checkboxText: {
                fontSize: '16px',
                fontWeight: '300',
                textTransform: 'initial',
                letterSpacing: '0.08px',
                lineHeight: '25px',
                color: 'black'
            },
            legalText: {
                fontSize: '13px',
                fontWeight: '300',
                lineHeight: '22px',
                letterSpacing: '0.065px',
                color: 'black.300'
            },
            error: {
                color: 'red.400',
                width: 'fit-content'
            },
            buttonSubmit: {
                bg: 'teal.500',
                color: 'white',
                margin: 'auto',
                borderRadius: '90px',
                height: '56px',
                width: '227px',
                fontSize: '17px',
                fontWeight: '400',

                _hover: {bg: 'teal.400'},
                _active: {bg: 'teal.400'}
            },
            alreadyAccount: {
                fontSize: '14px',
                color: 'gray.650',
                fontWeight: '300',
                letterSpacing: '0.07px',
                lineHeight: '22px'
            },
            loginLink: {
                fontSize: '14px',
                fontWeight: '400',
                color: 'black.100',
                lineHeight: '22px',
                letterSpacing: '0.07px',
                textDecoration: 'underline',
                textUnderlineOffset: '4px',

                _hover: {
                    color: 'teal.400'
                }
            },
            birthdayLabel: {
                fontSize: '16px',
                marginBottom: '30px',
                fontWeight: '300',
                color: 'black.300',
                display: 'block',
                lineHeight: '25px',
                letterSpacing: '0.08px',
                whiteSpace: 'normal'
            },
            birthdayGrid: {
                columns: {base: 4, lg: 6},
                columnGap: '30px',
                rowGap: '20px',
                margin: 'auto',
                maxWidth: {base: '335px', lg: '414px'},
                justifyItems: 'center'
            },
            birthdayVStack: {
                width: '44px',
                gap: '5px',
                cursor: 'pointer',
                align: 'center'
            },
            birthdayButton: {
                width: '42px',
                height: '42px',
                borderRadius: 'full',
                overflow: 'hidden'
            },
            birthdayImage: {
                width: '32px',
                height: '32px',
                margin: '5px',
                borderRadius: '50%',
                objectFit: 'cover',
                pointerEvents: 'none'
            },
            birthdayText: {
                fontSize: '14px',
                lineHeight: '22px',
                letterSpacing: '0.07px',
                color: 'black.300',
                fontWeight: '300'
            }
        }
    }
}

export default LoginSignUpForm
